import React from 'react';
import { List, Paper, Divider, Typography, ListItem } from '@mui/material';
import DailyCashDetailsItem from './DailyCashDetailsItem';
import { useTranslation } from 'react-i18next';

const DailyCashDetailsList = ({ items }) => {
  const { t } = useTranslation();
  return (
    <Paper elevation={0} sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', mt: 1 }}>
      <List sx={{ 
        flex: 1,
        overflow: 'auto'
      }}>
        {items.length > 0 ? (
          items.map((item, index) => (
            <React.Fragment key={`${item.type}-${item.id_finance_types_payment}-${index}`}>
              <DailyCashDetailsItem item={item} />
              {index < items.length - 1 && <Divider />}
            </React.Fragment>
          ))
        ) : (
          <ListItem>
            <Typography variant="subtitle1" sx={{ textAlign: 'center', width: '100%', py: 4 }}>
              {t('dailyCash.noDetails')}
            </Typography>
          </ListItem>
        )}
      </List>
    </Paper>
  );
};

export default DailyCashDetailsList; 